import React, { useState, useRef } from "react";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import axios from "axios";
import { UnidadMedida } from "./modalUnidadMedida";
import { Toasts } from "../toasts";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";

const headCells = [
  {
    id: "idunidadmedida",
    label: "CODIGO",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    width: "440px",
    textAlign: "left",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "180px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaUnidadesMedidas(props) {
  const txtBuscador = useRef();

  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const [mostrar5, setMostrar5] = useState(false);
  const [unidadMedida, setUnidadMedida] = useState();
  const [activate, setActivate] = useState(false);
  const [declaWeb] = useState(false);
  const [idusuario] = useState(localStorage.getItem("idusuario"));
  const [ip] = useState(localStorage.getItem("ip"));
  const [mac] = useState(localStorage.getItem("mac"));
  const permiso = JSON.parse(localStorage.getItem("accunimedi"));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacion, setOperacion] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idunidadmedida
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const blanquear = () => {
    setActivate(false);
    setUnidadMedida();
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "unidadmedida";
    let orden = "idunidadmedida";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
        txtBuscador.current?.focus();
      });
  };

  const seleccionarRegistro = (idunidadmedida) => {
    let campos = "*";
    let nomtab = "unidadmedida";
    let nomid = "idunidadmedida";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idunidadmedida}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idunidadmedida > 0) {
            setUnidadMedida(response.data);
            setMostrar5(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMostrar5(true);
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const consultarUnidadMedida = (ope, id, per) => (event) => {
    event.preventDefault();
    blanquear();
    if (per.toString() === "1") {
      if (ope === 1) {
        setMostrar5(true);
        setOperacion(1);
      } else if (ope === 4) {
        setOperacion(4);
        seleccionarRegistro(id);
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        setOperacion(3);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
              ? "No posee permiso para Editar"
              : ope === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  // useEffect(() => {
  //   seleccionarRegistros();
  //   /* seleccionarDeclaWeb(); */
  // }, []);

  const cerrar = () => {
    blanquear();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
    props.cerrar();
  };
  const cerrarModal = () => {
    if (props.onHideCancelar) {
      props.onHideCancelar();
    }
    if (props.setShow) props.setShow(false);

    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.cerrar();
  };
  const imprimir = () => {
    window.open(
      `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListUnidadMedida`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Gestion de Unidades de Medida.</h3>
        <a type="button" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-12">
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
              <input
                type={"text"}
                className="form-control text-uppercase"
                onChange={handleSearch}
                placeholder="Buscar Unidad de Medida..."
                ref={txtBuscador}
              />
              <button className="btn btn-sm btn-info" onClick={imprimir}>
                <i className="fas fa-print m-0"></i>
              </button>
            </div>
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              className="btn btn-sm btn-info"
              icon="fa-plus m-0"
              onClick={consultarUnidadMedida(
                1,
                "",
                permiso.toString().substring(1, 2),
              )}
              disabled={permiso.toString().substring(1, 2) !== "1"}
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idunidadmedida} style={{ padding: "0" }}>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idunidadmedida}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="mx-auto"
                      align="center"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <button
                        onClick={consultarUnidadMedida(
                          4,
                          item.idunidadmedida,
                          permiso.toString().substring(0, 1),
                        )}
                        className={
                          permiso.toString().substring(0, 1) === "1"
                            ? "btn btn-sm btn-info rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={consultarUnidadMedida(
                          2,
                          item.idunidadmedida,
                          permiso.toString().substring(2, 3),
                        )}
                        className={
                          permiso.toString().substring(2, 3) === "1"
                            ? "btn btn-sm btn-warning rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={consultarUnidadMedida(
                          3,
                          item.idunidadmedida,
                          permiso.toString().substring(3, 4),
                        )}
                        className={
                          permiso.toString().substring(3, 4) === "1"
                            ? "btn btn-sm btn-danger rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-trash-alt"></i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
        <UnidadMedida
          show={mostrar5}
          declaWeb={declaWeb}
          ip={ip}
          mac={mac}
          idusuario={idusuario}
          unidadMedida={unidadMedida}
          operacion={operacion}
          onHideRenderizar={seleccionarRegistros}
          onHideCancela={cerrarModalActualizar}
        />

        <Dimmer active={activate} inverted></Dimmer>

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
      </div>
    </Modal>
  );
}

export default TablaUnidadesMedidas;
